import { FileContentGUID, type VirtualFile } from "@pdfking/pdfengine"
import {
  ArrayToIterable,
  Keys,
  Map,
  StringHash,
  Values,
  Zip,
} from "@pdfking/tfunc"
import { BlobUrl } from "@pdfking/workflow/actions/pdfengine/BlobUrl"
import { ZipFiles } from "@pdfking/workflow/actions/pdfengine/Functions"

import download_url from "../actions/download_url"

export default async (
  mapping: Record<string, VirtualFile>,
  filename?: string
): Promise<void> => {
  const names = Keys(mapping)
  const files = Values(mapping)

  let file: VirtualFile
  let name: string

  if (files.length === 1) {
    name = names[0]
    file = files[0]
  } else {
    const hash = await StringHash(
      ArrayToIterable(names, Map(FileContentGUID, files))
    )
    name = filename || `${hash.toString(36)}.zip`
    file = await ZipFiles(Zip(names, files), { task_id: hash })
  }
  return download_url(await BlobUrl(file), name)
}
